// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.facturas span.input-group-text {
  border: none;
}

table.facturas > :not(:first-child) {
  border-top: none;
}

table.facturas th:last-child {
  text-align: center;
}

table.facturas tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

table.facturas td {
  padding-bottom: 1.75em;
  padding-top: 1.75em;
  vertical-align: middle;
}

table.facturas td:nth-child(2) {
  text-transform: capitalize;
}

.facturas-periodo,
.facturas-fecha,
.facturas-importe {
  text-align: center;
}

.facturas-periodo,
.facturas-importe {
  font-weight: 600;
}

.facturas-fecha {
  color: #a098ae;
}

.factura-download {
  display: flex;
}

.factura-pdf {
  color: #db0b27 !important;
  cursor: pointer;
  font-weight: 700;
}

.factura-pdf > .material-icons {
  display: inline;
  vertical-align: middle;
}

.facturas-cuentas-empty {
  background-color: #eaeaea;
  text-align: center;
  padding: 1em 10em;
}

.facturas-cuentas-empty-title {
  font-weight: 800;
  color: rgba(43, 54, 59, 0.75);
}

.facturas-account-card {
  border: 1px solid #dbdbdb;
  border-radius: 0.5em;
  padding: 1em;
  background-color: #fff;
  margin-left: 0em;
}

.facturas-cuentas-info-title {
  display: flex;
  gap: 1em;
  margin-bottom: 0.5em;
}

.facturas-cuentas-info-name {
  font-weight: 800;
  color: rgba(43, 54, 59, 0.75);
}

span.facturas-cuentas-info {
  font-style: italic;
}

p.facturas-cuentas-info {
  margin-bottom: 0.2em;
}

p.facturas-cuentas-info-inline {
  display: flex;
  justify-content: space-between;
  gap: 1em;
}

.input-group-text:has(.facturas-check-account-default) {
  border: none;
  padding: 0;
}

.facturas-check-account-default {
  width: 1em !important;
  height: 1em !important;
  line-height: 0.7em;
}

.facturas-check-account-default:checked {
  --bs-form-check-bg-image: none !important;
  content: none !important;
}

.facturas-check-account-default.form-check-input:checked {
  background-color: #fff;
  border: 1px solid #eaeaea;
}

.facturas-check-account-default.form-check-input[type="radio"]:checked::after {
  content: "✓" !important;
  color: #db0b27;
  font-size: 0.8em;
  font-weight: 900;
}

#buscadorFacturas {
  padding: 0 1em;
}

.filter-select-filters.facturas {
  display: flex;
  justify-content: space-evenly;
}

.filters-row.row {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

.filters-row > div > button.btn-primary {
  width: 100%;
}

/* BREAKPOINT TABLETS*/
@media (min-width: 768px) {
  table.facturas th {
    text-align: center;
  }

  .factura-pdf {
    text-align: center;
  }
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  .search-facturas-form {
    padding-right: 1em;
  }

  table.facturas tr,
  table.facturas td {
    border-bottom: none;
  }

  table.facturas thead {
    border-bottom: 1px solid #dbdbdb;
  }

  table.facturas th,
  table.facturas th:last-child,
  table.facturas td {
    text-align: left;
  }

  .filter-select-filters.facturas {
    display: block;
  }

  .filters-row.row {
    flex-direction: row;
    gap: 0;
  }

  .filters-row > div > button.btn-primary {
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/facturas/facturas.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,MAAM;EACR;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["table.facturas span.input-group-text {\n  border: none;\n}\n\ntable.facturas > :not(:first-child) {\n  border-top: none;\n}\n\ntable.facturas th:last-child {\n  text-align: center;\n}\n\ntable.facturas tr {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n}\n\ntable.facturas td {\n  padding-bottom: 1.75em;\n  padding-top: 1.75em;\n  vertical-align: middle;\n}\n\ntable.facturas td:nth-child(2) {\n  text-transform: capitalize;\n}\n\n.facturas-periodo,\n.facturas-fecha,\n.facturas-importe {\n  text-align: center;\n}\n\n.facturas-periodo,\n.facturas-importe {\n  font-weight: 600;\n}\n\n.facturas-fecha {\n  color: #a098ae;\n}\n\n.factura-download {\n  display: flex;\n}\n\n.factura-pdf {\n  color: #db0b27 !important;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.factura-pdf > .material-icons {\n  display: inline;\n  vertical-align: middle;\n}\n\n.facturas-cuentas-empty {\n  background-color: #eaeaea;\n  text-align: center;\n  padding: 1em 10em;\n}\n\n.facturas-cuentas-empty-title {\n  font-weight: 800;\n  color: rgba(43, 54, 59, 0.75);\n}\n\n.facturas-account-card {\n  border: 1px solid #dbdbdb;\n  border-radius: 0.5em;\n  padding: 1em;\n  background-color: #fff;\n  margin-left: 0em;\n}\n\n.facturas-cuentas-info-title {\n  display: flex;\n  gap: 1em;\n  margin-bottom: 0.5em;\n}\n\n.facturas-cuentas-info-name {\n  font-weight: 800;\n  color: rgba(43, 54, 59, 0.75);\n}\n\nspan.facturas-cuentas-info {\n  font-style: italic;\n}\n\np.facturas-cuentas-info {\n  margin-bottom: 0.2em;\n}\n\np.facturas-cuentas-info-inline {\n  display: flex;\n  justify-content: space-between;\n  gap: 1em;\n}\n\n.input-group-text:has(.facturas-check-account-default) {\n  border: none;\n  padding: 0;\n}\n\n.facturas-check-account-default {\n  width: 1em !important;\n  height: 1em !important;\n  line-height: 0.7em;\n}\n\n.facturas-check-account-default:checked {\n  --bs-form-check-bg-image: none !important;\n  content: none !important;\n}\n\n.facturas-check-account-default.form-check-input:checked {\n  background-color: #fff;\n  border: 1px solid #eaeaea;\n}\n\n.facturas-check-account-default.form-check-input[type=\"radio\"]:checked::after {\n  content: \"✓\" !important;\n  color: #db0b27;\n  font-size: 0.8em;\n  font-weight: 900;\n}\n\n#buscadorFacturas {\n  padding: 0 1em;\n}\n\n.filter-select-filters.facturas {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.filters-row.row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5em;\n}\n\n.filters-row > div > button.btn-primary {\n  width: 100%;\n}\n\n/* BREAKPOINT TABLETS*/\n@media (min-width: 768px) {\n  table.facturas th {\n    text-align: center;\n  }\n\n  .factura-pdf {\n    text-align: center;\n  }\n}\n\n/* BREAKPOINT ESCRITORIO */\n@media (min-width: 992px) {\n  .search-facturas-form {\n    padding-right: 1em;\n  }\n\n  table.facturas tr,\n  table.facturas td {\n    border-bottom: none;\n  }\n\n  table.facturas thead {\n    border-bottom: 1px solid #dbdbdb;\n  }\n\n  table.facturas th,\n  table.facturas th:last-child,\n  table.facturas td {\n    text-align: left;\n  }\n\n  .filter-select-filters.facturas {\n    display: block;\n  }\n\n  .filters-row.row {\n    flex-direction: row;\n    gap: 0;\n  }\n\n  .filters-row > div > button.btn-primary {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
